import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Motion";

const FOUNDER_IMG = "https://customer-assets-cm19k8pv.emergentagent.net/wingman/1d54338d-54b8-44b0-9db7-4c0dae9f7fd9/attachments/a14afeff05e64cc9be0dd034fde57cff_rodrigue_photo.jpg";
const FOUNDER_IMG_ALT = "Rodrigue CASSILDÉ, Architecte de Vie — Fondateur AETHERIS";

const VALUES = [
  { n: "01", t: "Exigence", d: "Aucun compromis sur la justesse. Chaque lecture est le fruit de quinze ans de pratique et de trois traditions." },
  { n: "02", t: "Souveraineté", d: "Vous rendre maître de votre destin — corps, mental, espace et lignée — jamais dépendant." },
  { n: "03", t: "Discrétion", d: "Un accompagnement d'élite, confidentiel, réservé aux bâtisseurs d'empire." },
];

export default function About() {
  return (
    <div className="pt-32 pb-24" data-testid="about-page">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-28">
          <Reveal>
            <p className="text-xs uppercase tracking-luxe text-gold mb-6">Le Fondateur</p>
            <h1 className="font-serif text-5xl md:text-7xl text-white leading-[0.95] mb-8">
              Rodrigue Cassildé
            </h1>
            <p className="text-white/60 font-light text-lg leading-relaxed mb-6">
              Fondateur et Directeur de l'Académie AETHERIS, Rodrigue Cassildé est
              l'autorité de référence en Architecture de Vie, Triple Fusion™ et Feng Shui
              Triple Fusion™.
            </p>
            <p className="text-white/60 font-light text-lg leading-relaxed">
              Depuis quinze ans, il accompagne dirigeants, entrepreneurs et bâtisseurs d'empire
              vers leur Souveraineté Totale. Sa méthode fusionne la parole ancestrale d'IFÀ, la
              rigueur géomantique de la grille Lo Shu et la précision de la numérologie
              pythagoricienne — quatre langues (fr, en, es, pt) au service d'une seule quête : la vôtre.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <img
              src={FOUNDER_IMG}
              alt={FOUNDER_IMG_ALT}
              data-testid="about-founder-photo"
              className="w-full max-w-sm mx-auto rounded-2xl shadow-2xl shadow-black/40 object-cover aspect-[3/4] border border-[#C9A96E]/30"
            />
            <p className="mt-6 text-xs uppercase tracking-luxe text-gold/60 text-center">
              Rodrigue Cassildé — Fondateur
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="max-w-4xl mx-auto mb-24">
          <blockquote
            className="relative pl-6 md:pl-10 py-6 border-l-2"
            style={{ borderColor: "#C9A96E" }}
            data-testid="triple-fusion-formula"
          >
            <p className="text-[11px] uppercase tracking-luxe text-gold/70 mb-4">La méthode</p>
            <p className="font-serif italic text-xl md:text-2xl leading-[1.5] text-white/90">
              <span className="text-gold not-italic font-normal">PYTHAGORE</span> décryptait les nombres.
              <span className="text-gold not-italic font-normal"> Lo Shu</span> décryptait l'espace.
              <span className="text-gold not-italic font-normal"> IFÀ</span> — Patrimoine immatériel de l'UNESCO — décryptait la destinée.
              <span className="text-white"> La Triple Fusion™ est la première méthode à réunir ces trois sagesses.</span>
            </p>
          </blockquote>
        </Reveal>

        <Reveal className="max-w-2xl mb-16">
          <h2 className="font-serif text-4xl md:text-5xl text-white leading-tight">Nos valeurs cardinales</h2>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10 mb-28">
          {VALUES.map((v, i) => (
            <Reveal key={v.n} delay={i * 0.1} className="bg-brand-ink p-8 md:p-12">
              <span className="font-serif text-6xl text-gold/30">{v.n}</span>
              <h3 className="font-serif text-2xl text-white mt-6 mb-3">{v.t}</h3>
              <p className="text-white/50 font-light leading-relaxed">{v.d}</p>
            </Reveal>
          ))}
        </div>

        <Reveal className="max-w-4xl mx-auto mb-24" data-testid="about-svh-section">
          <div className="border p-8 md:p-12" style={{ borderColor: "rgba(201,168,76,0.35)", background: "rgba(201,168,76,0.04)" }}>
            <p className="text-xs uppercase tracking-[0.25em] mb-4" style={{ color: "#C9A84C" }}>Structure légale</p>
            <h2 className="font-serif text-3xl md:text-4xl text-white mb-6">Le socle juridique</h2>
            <p className="text-white/70 font-light leading-relaxed text-base md:text-lg">
              L'Académie AETHERIS opère sous l'égide de <strong style={{ color: "#C9A84C" }}>Synergie VITA Holding (SVH)</strong>,
              SAS au capital de 500 €, immatriculée au RCS de Fort-de-France sous le SIREN{" "}
              <strong style={{ color: "#C9A84C" }}>108849241</strong>. SVH est le socle juridique et
              stratégique du déploiement de la méthode Triple Fusion™.
            </p>
          </div>
        </Reveal>

        <Reveal className="text-center">
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-8">Prêt à rencontrer votre matrice ?</h2>
          <Link to="/checkout/discovery_pack" data-testid="about-cta" className="inline-flex items-center gap-2 bg-gold text-brand-ink hover:bg-brand-gold-hover transition-colors px-10 py-5 text-sm uppercase tracking-[0.15em] font-semibold">
            Réserver mon Diagnostic Gratuit <ArrowUpRight size={18} />
          </Link>
        </Reveal>
      </div>
    </div>
  );
}
